import { createI18n } from 'vue-i18n'

import en from '~/locales/en.json'
import zh from '~/locales/zh.json'

export const i18n = createI18n({
  legacy: false,
  locale: 'en-US', // 默认语言，会被 store 中的值覆盖
  fallbackLocale: 'en-US',
  messages: {
    'en-US': en,
    'zh-CN': zh,
  },
})
